import { use } from "react";

import type { SettingsValue } from "@/context/settings-context";

import { SettingsContext } from "@/context/settings-context";

/**
 * Access theme settings (contrast mode + color-theme modal).
 *
 * @throws Error when used outside `SettingsProvider`
 */
export const useSettings = (): SettingsValue => {
	const context = use(SettingsContext);

	if (!context) {
		throw new Error("useSettings must be used within a SettingsProvider");
	}

	return context;
};
